import React from 'react';
import { openCookiePreferences } from './CookieConsent';

const Footer = () => {
  return (
    <footer className="w-full bg-gray-50 border-t border-gray-200 py-6">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <img 
              src={`${process.env.PUBLIC_URL}/stocker_logo.jpg`} 
              alt="Stocker Garden" 
              className="h-10 rounded"
            />
            <span className="text-sm text-gray-500">© 2026 Stocker S.r.l.</span>
          </div>
          <div className="flex items-center gap-6 text-sm text-gray-500 flex-wrap justify-center">
            <a href="https://www.stockergarden.com/privacy-policy/" className="hover:text-stocker-green transition-colors" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
            <button
              onClick={openCookiePreferences}
              className="hover:text-stocker-green transition-colors"
              data-testid="footer-cookie-prefs-btn"
            >
              Preferenze cookie
            </button>
            <a href="https://www.stockergarden.com" className="hover:text-stocker-green transition-colors" target="_blank" rel="noopener noreferrer">
              stockergarden.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
